export default __webpack_public_path__ + "static/media/gallery_09.956a5442.jpg";